import { State } from 'mk2/apps/bazaar/containers/SellerSearch/SellerSearch.reducers';
import { LoadingState } from 'mk2/reducers/loadingState';

export const ITEMS_PER_PAGE = 30;

export const initialState: State = {
    loadingState: LoadingState.INIT,
    errorMessage: null,
    ids: [],
    total: 0,
};
